import React from "react";
import { Box, Typography, Button, Grid, Card } from "@mui/material";
import Outlet from "../Container/outletCon";
import Cardspage from "../Container/card";
import BuildIcon from "@mui/icons-material/Build";
import VerifiedIcon from "@mui/icons-material/Verified";
import ElectricalServicesIcon from "@mui/icons-material/ElectricalServices";
import SpeedIcon from "@mui/icons-material/Speed";
import LocalCarWashIcon from "@mui/icons-material/LocalCarWash";
import HandymanIcon from "@mui/icons-material/Handyman";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

const services = [
  {
    icon: <BuildIcon sx={{ fontSize: 44, color: "#D12230" }} />,
    title: "Periodic Maintenance",
    desc: "Scheduled servicing including oil change, filter replacement, and full vehicle health check.",
  },
  {
    icon: <VerifiedIcon sx={{ fontSize: 44, color: "#D12230" }} />,
    title: "Genuine MG Parts",
    desc: "We use only authentic MG-certified spare parts to maintain the performance and warranty of your vehicle.",
  },
  {
    icon: <ElectricalServicesIcon sx={{ fontSize: 44, color: "#D12230" }} />,
    title: "EV & Electrical Service",
    desc: "Specialised battery diagnostics, charging system checks, and electrical repairs for MG EVs.",
  },
  {
    icon: <SpeedIcon sx={{ fontSize: 44, color: "#D12230" }} />,
    title: "Performance Check",
    desc: "Comprehensive multi-point inspection covering brakes, suspension, tyres, and engine systems.",
  },
  {
    icon: <LocalCarWashIcon sx={{ fontSize: 44, color: "#D12230" }} />,
    title: "Wash & Detailing",
    desc: "Professional exterior and interior cleaning, foam wash, and detailing to keep your car looking new.",
  },
  {
    icon: <HandymanIcon sx={{ fontSize: 44, color: "#D12230" }} />,
    title: "Accident Repair",
    desc: "Skilled body repair, dent removal, and paint restoration by our MG-certified technicians.",
  },
];

const whyChoose = [
  {
    icon: <EmojiEventsIcon sx={{ fontSize: 48, color: "#D12230" }} />,
    title: "MG Certified Technicians",
    desc: "Our team is factory-trained and certified by MG Motors to service all models with precision.",
  },
  {
    icon: <AccessTimeIcon sx={{ fontSize: 48, color: "#D12230" }} />,
    title: "Quick Turnaround",
    desc: "We value your time. Most services are completed same-day with real-time status updates.",
  },
  {
    icon: <SupportAgentIcon sx={{ fontSize: 48, color: "#D12230" }} />,
    title: "Dedicated Support",
    desc: "Our service advisors are available to guide you at every step — from booking to delivery.",
  },
];

const ServicePage = () => {
  const scrollTo = (id) => {
    const section = document.getElementById(id);
    if (section) section.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Box sx={{ overflowX: "hidden" }}>

      {/* Hero Banner */}
      <Box
        sx={{
          marginTop: "95px",
          width: "100%",
          height: { xs: "38vh", sm: "45vh", md: "55vh" },
          backgroundColor: "#1a1a1a",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          px: 2,
        }}
      >
        <Typography
          sx={{
            color: "#fff",
            fontFamily: "Roboto, sans-serif",
            fontWeight: "bold",
            fontSize: { xs: "20px", sm: "28px", md: "48px" },
            lineHeight: 1.2,
            mb: 1.5,
            letterSpacing: "2px",
          }}
        >
          MG CERTIFIED SERVICE CENTRE
        </Typography>
        <Typography
          sx={{
            color: "rgba(255,255,255,0.75)",
            fontSize: { xs: "12px", sm: "14px", md: "16px" },
            fontFamily: "Roboto, sans-serif",
            mb: { xs: 2, md: 3 },
          }}
        >
          Expert care for your MG — by MG-trained technicians
        </Typography>
        <Button
          variant="outlined"
          onClick={() => scrollTo("outlets")}
          sx={{
            borderColor: "white",
            color: "white",
            borderRadius: "50px",
            px: { xs: 3, md: 5 },
            py: { xs: 0.8, md: 1.2 },
            fontWeight: "bold",
            fontSize: { xs: "11px", md: "14px" },
            "&:hover": { backgroundColor: "rgba(255,255,255,0.1)", borderColor: "white" },
          }}
        >
          Book a Service
        </Button>
      </Box>

      {/* Services We Offer */}
      <Box sx={{ py: { xs: 6, md: 9 }, px: { xs: 2, md: 8 }, backgroundColor: "#fff" }}>
        <Typography
          sx={{
            color: "#D12230",
            fontWeight: "bold",
            fontSize: "12px",
            letterSpacing: "3px",
            textTransform: "uppercase",
            textAlign: "center",
            mb: 1,
            fontFamily: "Roboto, sans-serif",
          }}
        >
          What We Do
        </Typography>
        <Typography
          variant="h4"
          align="center"
          sx={{
            fontWeight: "bold",
            fontFamily: "Roboto, sans-serif",
            color: "#1a1a1a",
            mb: 5,
            fontSize: { xs: "22px", md: "32px" },
          }}
        >
          Services We Offer
        </Typography>
        <Grid container spacing={3} justifyContent="center">
          {services.map((s, i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Card
                elevation={0}
                sx={{
                  p: { xs: 3, md: 4 },
                  height: "100%",
                  border: "1.5px solid #eee",
                  borderRadius: "20px",
                  backgroundColor: "#fff",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: "0 16px 40px rgba(209,34,48,0.12)",
                    borderColor: "#D12230",
                  },
                }}
              >
                <Box sx={{ mb: 2 }}>{s.icon}</Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    fontFamily: "Roboto, sans-serif",
                    color: "#1a1a1a",
                    mb: 1,
                    fontSize: { xs: "16px", md: "18px" },
                  }}
                >
                  {s.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#666",
                    fontFamily: "Roboto, sans-serif",
                    lineHeight: 1.8,
                    fontSize: "13px",
                  }}
                >
                  {s.desc}
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Why Choose MG Service */}
      <Box sx={{ py: { xs: 6, md: 9 }, px: { xs: 2, md: 8 }, backgroundColor: "#f7f7f7" }}>
        <Typography
          sx={{
            color: "#D12230",
            fontWeight: "bold",
            fontSize: "12px",
            letterSpacing: "3px",
            textTransform: "uppercase",
            textAlign: "center",
            mb: 1,
            fontFamily: "Roboto, sans-serif",
          }}
        >
          Our Promise
        </Typography>
        <Typography
          variant="h4"
          align="center"
          sx={{
            fontWeight: "bold",
            fontFamily: "Roboto, sans-serif",
            color: "#1a1a1a",
            mb: 5,
            fontSize: { xs: "22px", md: "32px" },
          }}
        >
          Why Choose MG Service?
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          {whyChoose.map((item, i) => (
            <Grid item xs={12} sm={4} key={i}>
              <Box
                sx={{
                  textAlign: "center",
                  p: { xs: 3, md: 4 },
                  borderRadius: "20px",
                  backgroundColor: "#fff",
                  border: "1.5px solid #eee",
                  height: "100%",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: "0 12px 32px rgba(209,34,48,0.1)",
                    borderColor: "#D12230",
                  },
                }}
              >
                <Box sx={{ mb: 2 }}>{item.icon}</Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    fontFamily: "Roboto, sans-serif",
                    color: "#1a1a1a",
                    mb: 1.5,
                    fontSize: { xs: "16px", md: "18px" },
                  }}
                >
                  {item.title}
                </Typography>
                <Typography
                  sx={{
                    color: "#666",
                    fontFamily: "Roboto, sans-serif",
                    fontSize: "13px",
                    lineHeight: 1.8,
                  }}
                >
                  {item.desc}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Outlet */}
      <Box id="outlets">
        <Outlet />
      </Box>

      {/* Testimonials */}
      <Box id="testimonials">
        <Cardspage />
      </Box>

    </Box>
  );
};

export default ServicePage;
